var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThemeIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.374 8.08533C13.2899 8.40861 14.0011 9.1306 14.3352 10.0466H22.0185C21.512 4.96029 17.4602 0.908511 12.374 0.402039V8.08533Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3352 12.2017C14.0119 13.1177 13.2899 13.8289 12.374 14.163V21.8462C17.4602 21.3398 21.512 17.288 22.0185 12.2017H14.3352Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4968 8.08533C9.58081 8.40861 8.86959 9.1306 8.53553 10.0466H0.852246C1.35872 4.96029 5.41049 0.908511 10.4968 0.402039V8.08533Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53553 12.2017C8.85881 13.1177 9.58081 13.8289 10.4968 14.163V21.8462C5.41049 21.3398 1.35872 17.288 0.852246 12.2017H8.53553Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5043 12.466L32.7151 13.6768C33.0675 14.0292 33.0675 14.5984 32.7151 14.9508L24.6191 23.0468L22.1343 20.562L30.2303 12.466C30.5827 12.1136 31.1519 12.1136 31.5043 12.466ZM17.6164 24.854C17.6164 23.354 18.8272 22.1433 20.3271 22.1433C21.827 22.1433 23.0378 23.354 23.0378 24.854C23.0378 26.8509 21.4204 28.4683 19.4235 28.4683C18.0592 28.4683 16.6406 27.7635 15.8093 26.6611C16.5683 26.6611 17.6164 26.0377 17.6164 24.854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeIcon02);
export default __webpack_public_path__ + "static/media/theme_icon_02.cc8c6dc03a370927ad7b5d99240a03c4.svg";
export { ForwardRef as ReactComponent };